export interface IDropDownItem {
    id?: number,
    value: any,
    display: string
}